import { mapActions, mapGetters } from 'vuex';

export function VetPassportState(storeModule) {
  return {
    data() {
      return {
        vetPassport: {
          serial: null,
          number: null,
          date: null,
          issuedBy: null,
        },
      };
    },
    mounted() {
      this.vetPassport = {
        ...this.vetPassport,
        serial: this.getVetPassportSerial,
        number: this.getVetPassportNumber,
        date: this.getVetPassportDate,
        issuedBy: this.getVetPassportIssuedBy,
      };
    },
    computed: {
      ...mapGetters(storeModule, [
        'getVetPassportSerial',
        'getVetPassportNumber',
        'getVetPassportDate',
        'getVetPassportIssuedBy',
      ]),
    },
    methods: {
      ...mapActions(storeModule, [
        'setVetPassportSerial',
        'setVetPassportNumber',
        'setVetPassportDate',
        'setVetPassportIssuedBy',
      ]),
      vetPassportClear() {
        this.vetPassport = {
          ...this.vetPassport,
          serial: null,
          number: null,
          date: null,
          issuedBy: null,
        };
      },
    },
    watch: {
      'vetPassport.serial'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setVetPassportSerial(newValue);
        }
      },
      'vetPassport.number'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setVetPassportNumber(newValue);
        }
      },
      'vetPassport.date'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setVetPassportDate(newValue);
        }
      },
      'vetPassport.issuedBy'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setVetPassportIssuedBy(newValue);
        }
      },
    },
  };
}